import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { getUserManager } from "./oidc/userManager";

/**
 * Finish OIDC redirects before React Admin runs checkAuth.
 */
async function completeOidcRedirectIfNeeded() {
  const um = getUserManager();

  if (/\/auth\/callback\/?$/.test(window.location.pathname)) {
    try {
      await um.signinRedirectCallback();
      window.history.replaceState({}, document.title, "/");
    } catch (e) {
      console.error("OIDC sign-in callback failed:", e);
    }
    return;
  }

  if (/\/auth\/logout-callback\/?$/.test(window.location.pathname)) {
    localStorage.removeItem("role");
    try {
      await um.signoutRedirectCallback();
    } catch (e) {
      console.warn("OIDC sign-out callback failed; clearing local session:", e);
      await um.removeUser();
    }
    window.history.replaceState({}, document.title, "/login");
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));

completeOidcRedirectIfNeeded().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
